export default function Expired() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="text-center">
        <div className="text-6xl mb-4">&#9200;</div>
        <h1 className="text-3xl font-bold text-yellow-400 mb-4">
          Link Expired
        </h1>
        <p className="text-gray-400 max-w-md">
          This review link has expired or a decision has already been made.
          Please contact the producer if you need a new link.
        </p>
      </div>
    </div>
  );
}
